import { Address } from '../apis/graphql/types';

export const getAddressString = ({
  line1,
  city,
  state,
  zipCode,
}: Pick<Address, 'line1' | 'city' | 'state' | 'zipCode'>): string => {
  return `${line1}, ${city}, ${state}, ${zipCode}`;
};
